import React, {Component} from 'react';

import {
    Button
} from 'reactstrap';

class BoolButtons extends Component {
    state = {
        value: this.props.defaultValue === true ? 'true' : this.props.defaultValue === false ? 'false' : null
    };

    setValue = (value) => {
        this.setState({value: value});
        this.props.onChange && this.props.onChange(value);
    };

    render() {
        const value = this.state.value;
        const disabled = this.props.disabled;
        const inverse = this.props.inverse;
        const falseText = this.props.falseText || 'No';
        const trueText = this.props.trueText || 'Yes';
        const width = this.props.width || '5em';
        const size = this.props.size || 'sm';
        const falseColor = this.props.color || (inverse ? this.props.trueColor : this.props.falseColor) || (inverse ? 'success' : 'danger');
        const trueColor = this.props.color || (inverse ? this.props.falseColor : this.props.trueColor) || (inverse ? 'danger' : 'success');
        const onFalse = this.props.onFalse || (() => this.setValue('false'));
        const onTrue = this.props.onTrue || (() => this.setValue('true'));

        return (
            <div className="btn-bool-container">
                <Button color={falseColor}
                        style={{width: width, margin: size === 'lg' && '1em 1em'}}
                        className="btn-bool"
                        size={size}
                        outline={value !== 'false'}
                        onClick={onFalse}
                        disabled={disabled}>
                    {falseText}
                </Button>

                <Button color={trueColor}
                        style={{width: width, margin: size === 'lg' && '1em 1em'}}
                        className="btn-bool"
                        size={size}
                        outline={value !== 'true'}
                        onClick={onTrue}
                        disabled={disabled}>
                    {trueText}
                </Button>
            </div>
        );
    }
}

export default BoolButtons;


// WEBPACK FOOTER //
// ./src/components/controls/buttons/BoolButtons.js